import { Star } from "lucide-react";
import { SectionHeading } from "./shared";

export default function TestimonialsSection({ t }) {
  if (!t.testimonials) return null;
  return (
    <section className="bg-[#FAF5EE] py-16 sm:py-24 lg:py-32" data-testid="weddings-testimonials">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-10">
        <SectionHeading
          eyebrow={t.testimonialsEyebrow}
          title={t.testimonialsTitle}
          titleAccent={t.testimonialsTitleAccent}
          subtitle={t.testimonialsSubtitle}
        />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
          {t.testimonials.map((r, i) => {
            const initials = r.name.split(/\s|&/).filter(Boolean).slice(0, 2).map(s => s[0]).join("");
            return (
              <article key={i}
                       className="relative bg-white p-7 sm:p-8 lg:p-9 rounded-sm border border-[#EFE4D2] hover:border-[#C9A87C]/60 hover:shadow-[0_18px_45px_-20px_rgba(31,24,21,0.25)] transition-all duration-500"
                       data-testid={`weddings-testimonial-${i}`}>
                <div className="absolute -top-4 left-7 sm:left-8 w-10 h-10 rounded-full bg-[#C9A87C] text-white flex items-center justify-center text-2xl"
                     style={{ fontFamily: "'Cormorant Garamond', serif" }} aria-hidden="true">“</div>
                <div className="flex items-center gap-1 mb-4 sm:mb-5 pt-1">
                  {Array.from({ length: r.rating || 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#C9A87C] text-[#C9A87C]" />
                  ))}
                </div>
                <p className="text-sm sm:text-[15px] text-[#3D2F22] font-light leading-[1.7] mb-6 sm:mb-7 italic"
                   style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.05rem", lineHeight: 1.7 }}>
                  {r.quote}
                </p>
                <div className="flex items-center gap-3 sm:gap-4 pt-4 sm:pt-5 border-t border-[#EFE4D2]">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-[#D4B896] to-[#8B6F47] text-white flex items-center justify-center font-medium text-sm sm:text-base shrink-0 shadow-sm">
                    {initials}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="text-sm sm:text-[15px] font-medium text-[#1F1815] leading-tight">{r.name}</div>
                    <div className="text-xs text-[#8B6F47] mt-1 leading-snug">{r.location}<br className="sm:hidden" /><span className="hidden sm:inline"> · </span>{r.date}</div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
